import { render } from "./equity-company.vue?vue&type=template&id=4c35c442"
import script from "./equity-company.vue?vue&type=script&lang=js"
export * from "./equity-company.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__